/**
 * 定义应用路由
 */
import React, { Suspense } from 'react';
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import routes from './routerConfig';

const Loading = () => (
  <div style={{ padding: 60, textAlign: 'center', color: '#6b7280', fontSize: 14 }}>加载中…</div>
);

// 浏览器没有 node 的 path 模块, 用字符串拼接代替 path.join
const joinPath = (a, b) => `${String(a).replace(/\/+$/, '')}/${String(b).replace(/^\/+/, '')}`;

const RouteItem = (props) => {
  const { redirect, path: routePath, component, key } = props;
  if (redirect) {
    return (
      <Redirect
        exact
        key={key}
        from={routePath}
        to={redirect}
      />
    );
  }
  return (
    <Route
      key={key}
      component={component}
      path={routePath}
    />
  );
};

const router = () => {
  return (
    <Router>
      <Suspense fallback={<Loading />}>
      <Switch>
        {routes.map((route, id) => {
          const { component: RouteComponent, children, ...others } = route;
          return (
            <Route
              key={id}
              {...others}
              component={(props) => {
                return (
                  children ? (
                    <RouteComponent key={id} {...props}>
                      <Switch>
                        {children.map((routeChild, idx) => {
                          const { redirect, path: childPath, component } = routeChild;
                          return RouteItem({
                            key: `${id}-${idx}`,
                            redirect,
                            path: childPath && joinPath(route.path, childPath),
                            component,
                          });
                        })}
                      </Switch>
                    </RouteComponent>
                  ) : (
                    <>
                      {
                        RouteItem({
                          key: id,
                          ...props,
                        })
                      }
                    </>
                  )
                );
              }}
            />
          );
        })}
      </Switch>
      </Suspense>
    </Router>
  );
};

export default router;
